var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "550px" },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function ({ on, attrs }) {
              return [_vm._t("clickable", null, { on: on, attrs: attrs })]
            },
          },
        ],
        null,
        true
      ),
      model: {
        value: _vm.vSync,
        callback: function ($$v) {
          _vm.vSync = $$v
        },
        expression: "vSync",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v(
              " Are you sure you want to " +
                _vm._s(_vm.action) +
                " this " +
                _vm._s(_vm.type) +
                "? "
            ),
          ]),
          _c("v-card-text", [_vm._v(" " + _vm._s(_vm.message) + " ")]),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("cancel")
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "blue darken-1",
                    "data-cy": "deleteConfirm",
                    text: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("confirm")
                    },
                  },
                },
                [_vm._v(" OK ")]
              ),
              _c("v-spacer"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }